export const ROUTES = {
  HOME: '',
  ABOUT_US: 'about-us',
  COOKIE_POLICY: 'cookie-policy',
  EMPLOYER: 'employer',
  REGISTRATION: 'registration',
  REGISTRATION_STARTED: 'registration-started',
  REGISTRATION_COMPLETED: 'registration-completed',
  REGISTRATION_INTERMEDIATE: 'registration-intermediate',
  CANDIDATE: 'candidate',
  CANDIDATE_LOGGED_HOME: 'private/candidate',
  EMPLOYER_LOGGED_HOME: 'private/employer',
  PROFILE: 'profile',
  PRIVACY_POLICY: 'privacy-policy',
  CREATE_OPPORTUNITY: 'create-opportunity',
  DETAIL_OPPORTUNITY: 'detail-opportunity/:id',
  UPDATE_OPPORTUNITY: 'update-opportunity/:id',
  YOURS_OPPORTUNITIES: 'yours-opportunities',
  MESSAGES: 'messages',
  DASHBOARD: 'dashboard',
  PAYSLIPS_MANAGEMENT: 'payslips-management',
  TIME_TRACKING_MANAGEMENT: 'time-tracking-management',
  ARCHIVED_DOCUMENTS: 'archived-documents',
  WHISTLEBLOWING: 'whistleblowing',
  WHISTLEBLOWING_DETAIL: 'whistleblowing/:ticketId',
  REFOUND: 'rimborsi',
  DISPUTE_CENTER: 'dispute-center',
  DISPUTE_CENTER_DETAIL: 'dispute-center/:ticketId',
  SEPA_DIRECT_DEBIT: 'sepa-direct-debit',
  GRENS_INVOICING: 'grens-invoicing',
  INVITE_COLLABORATORS: 'invite-collaborators',
  EMPLOYEES_MANAGEMENT: 'employees-management',
  EMPLOYEE_MANAGEMENT_DASHBOARD: ':employeeId/dashboard',
  SHIFTS_MANAGEMENT: 'shifts-management',
  CONTRACT_MANAGEMENT: 'contract-management',
  CONTRACT_MANAGEMENT_DETAIL: 'contract-management/:contractId',
  LOCATION_BY_ID_ROUTE : 'location-management/:id',
  LOCATIONS_EDIT_BY_ID: 'location-management/edit/:id',
  ATTENDANCE_SHEET: 'attendance-sheet',
  ATTENDANCE_SHEET_DETAIL: 'attendance-sheet/:idAttendance',
  REFUNDS_MANAGEMENT: 'refunds'
};
